import { render, staticRenderFns } from "./RegisterForPassportNumber.vue?vue&type=template&id=0661cb26&"
import script from "./RegisterForPassportNumber.vue?vue&type=script&lang=js&"
export * from "./RegisterForPassportNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports